export const SET_LOGIN_FLAG = "SET_LOGIN_FLAG";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_USER_AUTHTOKEN = "SET_USER_AUTHTOKEN";
export const USER_LOGOUT = "USER_LOGOUT";

export const SET_TOGGLE_BTN = "SET_TOGGLE_BTN"

export const SET_USERS = "SET_USERS";
export const SET_PROPOSALS = "SET_PROPOSALS";
export const SET_ENQUIRIES = "SET_ENQUIRIES";